import React, {useEffect, useState} from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";

const usePrivacy = () => {
    const navigate = useNavigate();
    const [ready, setReady] = useState(false);

    useEffect(() => {
        // Fetch the user's IP address
        console.log('env type', process.env.NODE_ENV)
        if(process.env.NODE_ENV !== 'development') {
            axios.get('https://api.ipify.org?format=json')
                .then(response => {
                    if (response.data.ip !== process.env.REACT_APP_OFFICE_IP) {
                        navigate('/404');
                    }
                    setReady(true)
                })
                .catch(error => {
                    console.error('Error fetching the IP address:', error);
                    navigate('/404');
                });
        } else {
            setReady(true)
        }
    }, []);

    return ready;
};

export default usePrivacy;